import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './WorkflowTask.scss'
import WorkflowStatusIcon from './WorkflowStatusIcon'
import Skeleton from '../loaders/Skeleton'
import HrbTranslate from '../../language/HrbTranslate';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { TaskStatus } from '../../../pages/vdo-ticket/services/TaskStatus';

const WorkflowTask = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Fragment>
            <div className='columns task-holder mx-0' id={`task_header_${props.taskId}`}>
                <div className='column is-10 is-offset-1'>
                    <div className={classnames('columns level workflow-task-header', { 'task-open': isOpen })} onClick={() => setIsOpen(!isOpen)}>
                        <div className='column is-1'>
                            <WorkflowStatusIcon status={props.status || TaskStatus.NOT_STARTED} />
                        </div>
                        <div className='column is-5'>
                            {!props.taskId &&
                                <Skeleton />
                            }
                            {props.taskId &&
                                <h5 className='hnav-tabs'><HrbTranslate text={`Tickets.Tasks.DisplayNames.${props.taskId}`} /></h5>
                            }
                        </div>
                        <div className='column is-5'>
                            {!props.status &&
                                <Skeleton width='200px' />
                            }
                            {props.status &&
                                <h5 className='hnav-tabs'><HrbTranslate text={`Tickets.Tasks.TaskStatus.${props.status}`} /></h5>
                            }
                        </div>
                        <div className='column is-1' onClick={() => setIsOpen(!isOpen)}>
                            <div className='expand-btns is-green'>
                                {isOpen &&
                                    <ExpandLess />
                                }
                                {!isOpen &&
                                    <ExpandMore />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isOpen &&
                <div className='columns mx-0' id={`task_content_${props.taskId}`}>
                    <div className='column is-10 is-offset-1 px-0'>
                        <div className='workflow-task task-open'>
                            {props.children}
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    );
}

WorkflowTask.propTypes = {
    taskId: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    loading: PropTypes.bool
}

export default WorkflowTask